import React from "react";

interface Props {
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

const ClientPagination: React.FC<Props> = ({ page, pageSize, totalCount, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const start = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalCount);

  if (totalCount === 0) return null;

  return (
    <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200">
      <p className="text-sm text-gray-700">
        Showing <span className="font-medium">{start}</span> to <span className="font-medium">{end}</span> of{" "}
        <span className="font-medium">{totalCount}</span> results
      </p>
      <div className="inline-flex rounded-md shadow-sm -space-x-px">
        <button onClick={() => onPageChange(1)} disabled={page === 1} className="px-3 py-2 border border-gray-300 bg-white text-sm rounded-l-md disabled:opacity-50">
          First
        </button>
        <button onClick={() => onPageChange(page - 1)} disabled={page === 1} className="px-3 py-2 border border-gray-300 bg-white text-sm disabled:opacity-50">
          Previous
        </button>
        <span className="px-4 py-2 border border-gray-300 bg-primary-50 text-primary-700 text-sm">
          {page} / {totalPages}
        </span>
        <button onClick={() => onPageChange(page + 1)} disabled={page === totalPages} className="px-3 py-2 border border-gray-300 bg-white text-sm disabled:opacity-50">
          Next
        </button>
        <button onClick={() => onPageChange(totalPages)} disabled={page === totalPages} className="px-3 py-2 border border-gray-300 bg-white text-sm rounded-r-md disabled:opacity-50">
          Last
        </button>
      </div>
    </div>
  );
};

export default ClientPagination;
